module.exports = __webpack_public_path__ + "static/media/AvalancheFriends5.fd107219.jpg";